import { render, staticRenderFns } from "./addBillCertDialog.vue?vue&type=template&id=5fb75f23"
import script from "./addBillCertDialog.vue?vue&type=script&lang=js"
export * from "./addBillCertDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports